<template>
  <div v-if="shares && shares.length" class="home-banners">
    <div class="container">
      <div class="home-banners__list">
        <div class="home-banners__item" v-for="(item, i) in shares" :key="i">
          <SlideComponent :data="item" is-share />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SlideComponent from "components/SlideComponent.vue";

export default {
  name: "BannerSharesComponent",
  props: {
    shares: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: { SlideComponent },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/ratio.styl"
.home-banners {
	padding: 0 30px
	+below(840px) {
		padding: 0 15px
	}

  &__list {
    padding-top 30px
    display flex
    flex-wrap wrap
    gap 30px
    background: var(--white)
    border-radius: calc(var(--main_radius) * 2)
    +below(840px) {
			padding-top: 10px
      border-radius 0
      gap 20px
    }
    +below(720px) {
      flex-wrap: nowrap
      overflow-x: auto
			scrollbar-width: none
    }
  }

  &__item {
    border-radius: var(--main_radius);
    overflow: hidden;
    width calc(33.333333% - 20px)
    +below(840px) {
      width calc(33.333333% - 14px)
    }
    +below(720px) {
      width 90%
      flex-shrink 0
    }

    .main-slide {
      ratio(393, 350)
      height 100%
      +below(720px) {
        ratio(605, 350)
      }
    }

    &:nth-child(-n+2) {
      width calc(50% - 15px)
      +below(840px) {
        width calc(50% - 10px)
      }
      +below(720px) {
        width 90%
        flex-shrink 0
      }

      .main-slide {
        ratio(605, 350)
        height 100%
      }
    }
  }
}
</style>
